import React from 'react';
import classNames from 'classnames';

import SeeMoreButton from '../SeeMoreButton';
import SearchEventCard from '../SearchEventCard';

import { GA_VIEW_MORE_ACTION } from '../../constants';

const getCards = (
    cards,
    isMobile,
    onSaveEvent,
    shareOptions,
    isAuthenticated,
    onTrackClick,
    onTrackClickInternal,
    trackGAEvent,
    experiments,
    featureFlags,
    userCollections,
    onAddOrRemoveEventToCollection,
    onCreateCollection,
    followCountVariant,
) => {
    const classes = classNames({
        'eds-g-cell eds-g-cell-3-12 eds-g-cell--has-overflow': !isMobile,
        'small-card-mobile': isMobile,
    });

    return cards.map(({ id, ...cardProps }, index) => (
        <div className={classes} key={id}>
            <SearchEventCard
                id={id}
                onSaveEvent={onSaveEvent}
                shareOptions={shareOptions}
                isAuthenticated={isAuthenticated}
                trackGAEvent={trackGAEvent}
                trackClick={onTrackClick.bind(null, { id })}
                trackClickInternal={onTrackClickInternal.bind(null, index)}
                experiments={experiments}
                featureFlags={featureFlags}
                userCollections={userCollections}
                onAddOrRemoveEventToCollection={onAddOrRemoveEventToCollection}
                onCreateCollection={onCreateCollection}
                followCountVariant={followCountVariant}
                {...cardProps}
            />
        </div>
    ));
};

const SmallEventCardGroup = ({
    cards,
    linkUrl,
    onSaveEvent,
    shareOptions,
    isAuthenticated,
    onTrackClick,
    title,
    onTrackClickInternal,
    trackGAEvent,
    experiments,
    featureFlags,
    userCollections,
    onAddOrRemoveEventToCollection,
    onCreateCollection,
    followCountVariant,
}) => (
    <div className="browse-cards-container">
        <div className="eds-show-up-md">
            {getCards(
                cards,
                false,
                onSaveEvent,
                shareOptions,
                isAuthenticated,
                onTrackClick,
                onTrackClickInternal,
                trackGAEvent,
                experiments,
                featureFlags,
                userCollections,
                onAddOrRemoveEventToCollection,
                onCreateCollection,
                followCountVariant,
            )}
        </div>
        <div className="eds-show-down-mn">
            <div className="mobile-card-carousel eds-l-mar-bot-4">
                {getCards(
                    cards,
                    true,
                    onSaveEvent,
                    shareOptions,
                    isAuthenticated,
                    onTrackClick,
                    onTrackClickInternal,
                    trackGAEvent,
                    experiments,
                    featureFlags,
                    userCollections,
                    onAddOrRemoveEventToCollection,
                    onCreateCollection,
                    followCountVariant,
                )}
            </div>
            <div className="eds-show-down-sn eds-align--center">
                <div className="eds-g-cell">
                    <SeeMoreButton
                        linkUrl={linkUrl}
                        trackClick={onTrackClick}
                        title={title}
                        gaAction={GA_VIEW_MORE_ACTION}
                    />
                </div>
            </div>
        </div>
    </div>
);

export default SmallEventCardGroup;
